module.exports = __webpack_public_path__ + "images/accents/accent-comments@1x-6d5214c8702ee87cf9cb2c6225b148e6.webp";